"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLog = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Creates a new log.
 *
 * ## Usage
 *
 * ```ts
 * const log: Omit<LogComplete, '_id'> = {
 * 	type: LogType.COMPLETE,
 *  memberId: "453627890348576",
 *  gameId: 56780,
 * };
 *
 * const {
 * 	acknowledged,
 * 	insertedId,
 * } = await sdk.createLog({ log });
 * ```
 *
 * @param params.log - Data of the new log. Only the fields from base Log type are required, and the rest depends on the log type.
 */
const createLog = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { log } = params;
    const url = `${BASE_URL}/logs`; // TODO Create this endpoint
    const logResponse = yield axios_1.default.post(url, log, { validateStatus: () => true });
    const { status, data } = logResponse;
    if (status !== 201)
        throw new Error(data.error);
    return data;
});
exports.createLog = createLog;
